/* eslint-disable max-params */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import PriceCurrency from '@tcp/core/src/components/common/molecules/PriceCurrency';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { getIconPath, isMobileWeb } from '@tcp/core/src/utils';
import styles from '../styles/CollapsableError.style';
import CartItemTileLabels, {
  CHECKOUT_LABELS,
} from '../../../../CartItemTile/molecules/CartItemTile/views/CartItemTile.labels';
import PriceDropNotificationModalView from '../../../../CartItemTile/molecules/PriceDropNotificationModal/views/PriceDropNotificationModal.view';

const globalLabels = getLabelFromCopyOrFromTranslation('global', CartItemTileLabels) || {};

const moveItems = (bossUnavailableProducts, moveItemsToBossUnavailableListAction) => {
  if (bossUnavailableProducts && bossUnavailableProducts?.length > 0) {
    moveItemsToBossUnavailableListAction(bossUnavailableProducts);
  }
};

const getRemoveString = ({
  labelMsg,
  removeCartItem,
  getUnavailableOOSItems,
  bossUnavailableProducts,
  pageView,
  bossUnavailableSwitch,
  isBossCart,
  isBossUnavailable,
  orderItems,
  getBossUnavailableItems,
  moveItemsToBossUnavailableListAction,
}) => {
  const { minibag } = globalLabels || {};
  const checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, CartItemTileLabels);
  const isMiniBag = pageView !== 'myBag';
  const newLabel = renderLabel(
    getDynamicLabelValues('dynamic.cart.lbl_boss_unavailable_group_header_error'),
    'lbl_boss_unavailable_group_header_error'
  );

  const isAllBossUnavailable = orderItems?.size === getBossUnavailableItems?.length;
  const showBossUnavailableError = !isAllBossUnavailable && isBossUnavailable;
  const remove =
    bossUnavailableSwitch && isBossCart && showBossUnavailableError
      ? newLabel?.split('#S2H')
      : labelMsg && labelMsg.split('#remove#');

  const newRemove =
    bossUnavailableSwitch && isBossCart && showBossUnavailableError ? (
      <BodyCopy
        fontFamily="secondary"
        fontSize={isMobileWeb() || isMiniBag ? 'fs12' : 'fs14'}
        component="span"
        className="removeErrorMessage"
        onClick={() => moveItems(bossUnavailableProducts, moveItemsToBossUnavailableListAction)}
      >
        {renderLabel(
          checkoutLabels?.bagPage?.lbl_boss_unavailable_global_error_subtext,
          'lbl_boss_unavailable_global_error_subtext'
        )}
      </BodyCopy>
    ) : (
      <BodyCopy
        fontFamily="secondary"
        fontSize={isMobileWeb() || isMiniBag ? 'fs12' : 'fs14'}
        component="span"
        className="removeErrorMessage"
        onClick={() => removeCartItem({ getUnavailableOOSItems, isMiniBag })}
      >
        {renderLabel(minibag?.lbl_minibag_errorRemove, 'lbl_minibag_errorRemove')}
      </BodyCopy>
    );
  if (remove) {
    remove.splice(1, 0, newRemove);
  }

  return remove;
};

const priceDropNotificationSubHeader = (
  priceNotificationModalOpen,
  setPriceNotificationModalOpen,
  cartProducts,
  sflProducts
) => {
  const cartItemName = cartProducts?.[0]?.productInfo?.name;
  const sflItemName = sflProducts?.[0]?.productInfo?.name;

  const cartItemPrice = cartProducts?.[0]?.itemInfo?.itemUnitPrice;
  const sflItemPrice = sflProducts?.[0]?.itemInfo?.offerPrice;

  const singleItemName = cartProducts?.length === 1 ? cartItemName : sflItemName;
  const singleItemPrice = cartProducts?.length === 1 ? cartItemPrice : sflItemPrice;

  return cartProducts?.length > 1 ||
    sflProducts?.length > 1 ||
    cartProducts?.length + sflProducts?.length > 1 ? (
    <>
      <BodyCopy
        tag="span"
        fontSize={isMobileWeb() ? 'fs12' : 'fs14'}
        fontWeight="medium"
        textAlign="left"
        fontFamily="secondary"
        className="error-subheader-text-msg-container"
      >
        <BodyCopy
          tag="span"
          fontSize={isMobileWeb() ? 'fs12' : 'fs14'}
          fontWeight="bold"
          textAlign="left"
          fontFamily="secondary"
          className="price-drop-notification-view-items"
          onClick={() => setPriceNotificationModalOpen(!priceNotificationModalOpen)}
        >
          {renderLabel(
            getDynamicLabelValues('dynamic.cart.lbl_priceDrop_viewItems'),
            'lbl_priceDrop_viewItems'
          )}
        </BodyCopy>
      </BodyCopy>
      <PriceDropNotificationModalView
        isOpen={priceNotificationModalOpen}
        closeModal={setPriceNotificationModalOpen}
        cartProducts={cartProducts}
        sflProducts={sflProducts}
      />
    </>
  ) : (
    <BodyCopy
      tag="span"
      fontSize={isMobileWeb() ? 'fs12' : 'fs14'}
      fontWeight="medium"
      textAlign="left"
      fontFamily="secondary"
    >
      {renderLabel(
        getDynamicLabelValues('dynamic.cart.lbl_priceDrop_singleItem_subHeader'),
        'lbl_priceDrop_singleItem_subHeader'
      ).replace('#singleItemName#', singleItemName)}

      <BodyCopy
        className="price-label product-price"
        fontFamily="secondary"
        component="span"
        fontSize={isMobileWeb() ? 'fs12' : 'fs14'}
        fontWeight={['extrabold']}
      >
        <PriceCurrency price={Number(singleItemPrice)} />
      </BodyCopy>
    </BodyCopy>
  );
};

const renderSubHeaderComponent = (
  fromPriceDropNotification,
  priceNotificationModalOpen,
  setPriceNotificationModalOpen,
  cartProducts,
  sflProducts,
  isMiniBag,
  subheader
) => {
  return fromPriceDropNotification ? (
    priceDropNotificationSubHeader(
      priceNotificationModalOpen,
      setPriceNotificationModalOpen,
      cartProducts,
      sflProducts
    )
  ) : (
    <BodyCopy
      tag="span"
      fontSize={isMobileWeb() || isMiniBag ? 'fs12' : 'fs14'}
      fontWeight="medium"
      textAlign="left"
      fontFamily="secondary"
      className="error-subheader-text-msg"
    >
      {subheader}
    </BodyCopy>
  );
};

const CollapsableError = ({
  header,
  className,
  pageView,
  removeCartItem,
  getUnavailableOOSItems,
  isSoldOut,
  isUnavailable,
  bossUnavailableProducts,
  isBossUnavailable,
  bossUnavailableSwitch,
  isBossCart,
  orderItems,
  getBossUnavailableItems,
  moveItemsToBossUnavailableListAction,
  fromPriceDropNotification,
  cartProducts,
  sflProducts,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [priceNotificationModalOpen, setPriceNotificationModalOpen] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const { minibag } = globalLabels || {};
  const labelMsg =
    (isSoldOut &&
      renderLabel(
        minibag?.lbl_minibag_errorRemoveSoldoutHeader,
        'lbl_minibag_errorRemoveSoldoutHeader'
      )) ||
    (isUnavailable &&
      renderLabel(
        minibag?.lbl_minibag_errorUpdateUnavailable,
        'lbl_minibag_errorUpdateUnavailable'
      )) ||
    (isBossUnavailable &&
      renderLabel(
        minibag?.lbl_minibag_errorUpdateUnavailable,
        'lbl_minibag_errorUpdateUnavailable'
      ));

  const subheader = getRemoveString({
    labelMsg,
    removeCartItem,
    getUnavailableOOSItems,
    bossUnavailableProducts,
    pageView,
    bossUnavailableSwitch,
    isBossCart,
    isBossUnavailable,
    orderItems,
    getBossUnavailableItems,
    moveItemsToBossUnavailableListAction,
  });

  const isMiniBag = pageView !== 'myBag';

  return (
    <div className={className}>
      <div
        className={`${
          fromPriceDropNotification && 'price-drop-notification-container'
        } error-container`}
      >
        <div className="error-inner-container">
          <div className="error-header-arrow-container">
            <BodyCopy
              tag="span"
              fontSize={isMobileWeb() || isMiniBag ? 'fs13' : 'fs16'}
              fontWeight="extrabold"
              textAlign="left"
              fontFamily="secondary"
              className="error-header-text-msg"
            >
              {header}
            </BodyCopy>
            <button className="toggle-arrow" onClick={toggleExpand}>
              {isExpanded ? (
                <Image src={getIconPath('down_arrow_icon')} alt="down_arrow_icon" />
              ) : (
                <Image src={getIconPath('up_arrow_icon')} alt="up_arrow_icon" />
              )}
            </button>
          </div>

          <div className={`error-subheader-container ${isExpanded ? 'expanded' : 'collapsed'}`}>
            {renderSubHeaderComponent(
              fromPriceDropNotification,
              priceNotificationModalOpen,
              setPriceNotificationModalOpen,
              cartProducts,
              sflProducts,
              isMiniBag,
              subheader
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

CollapsableError.propTypes = {
  header: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default withStyles(CollapsableError, styles);

export { CollapsableError };
